module.exports = __webpack_public_path__ + "img/avatar-55.174e9238.png";